import { COLORS } from '@app/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useTradeStore from '../../../../hooks/trade/tradeStore';
import { OrderBookHeaderSection, Price, Quantity, Total } from './styles';

const OrderBookHeader = () => {
  const { t } = useTranslation();

  const { data: store } = useTradeStore();

  const orderType = store?.main_sub;
  const current = store?.pairs?.split('/');

  const color = COLORS.lightGray;

  return (
    <OrderBookHeaderSection>
      <Price style={{ color, fontSize: '1.1rem' }}>
        {t('price')} ({current?.[1]})
      </Price>
      <Quantity
        style={{
          color,
          fontSize: '1.1rem',
          textAlign: 'right',
        }}
      >
        {t('amount')} ({orderType === 'M' ? current?.[0] : current?.[1]})
      </Quantity>
      <Total
        style={{
          color,
          fontSize: '1.1rem',
          textAlign: 'right',
          marginLeft: '10px',
          minWidth: '90px',
        }}
      >
        {t('total')} ({orderType === 'M' ? current?.[0] : current?.[1]})
      </Total>
    </OrderBookHeaderSection>
  );
};

export default OrderBookHeader;
